module.exports = __webpack_public_path__ + "img/ruby-post.5ddd9352.jpeg";